var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H18.75C25.5375 1.5625 28.4375 4.4625 28.4375 11.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375ZM11.25 3.4375C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V11.25C26.5625 5.4875 24.5125 3.4375 18.75 3.4375H11.25Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7117 20.0252C10.4742 20.0252 10.2367 19.9377 10.0492 19.7502C9.68672 19.3877 9.68672 18.7877 10.0492 18.4252L18.2367 10.2377C18.5992 9.8752 19.1992 9.8752 19.5617 10.2377C19.9242 10.6002 19.9242 11.2002 19.5617 11.5627L11.3742 19.7502C11.1867 19.9377 10.9492 20.0252 10.7117 20.0252Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.225 13.8875C9.86251 13.8875 8.75 12.775 8.75 11.4125C8.75 10.05 9.86251 8.9375 11.225 8.9375C12.5875 8.9375 13.7 10.05 13.7 11.4125C13.7 12.775 12.5875 13.8875 11.225 13.8875ZM11.225 10.825C10.9 10.825 10.625 11.0875 10.625 11.425C10.625 11.7625 10.8875 12.025 11.225 12.025C11.5625 12.025 11.825 11.7625 11.825 11.425C11.825 11.0875 11.55 10.825 11.225 10.825Z",
    fill: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3998 21.0501C18.0373 21.0501 16.9248 19.9376 16.9248 18.5751C16.9248 17.2126 18.0373 16.1001 19.3998 16.1001C20.7623 16.1001 21.8748 17.2126 21.8748 18.5751C21.8748 19.9376 20.7623 21.0501 19.3998 21.0501ZM19.3998 17.9876C19.0748 17.9876 18.7998 18.2501 18.7998 18.5876C18.7998 18.9251 19.0623 19.1876 19.3998 19.1876C19.7373 19.1876 19.9998 18.9251 19.9998 18.5876C19.9998 18.2501 19.7373 17.9876 19.3998 17.9876Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFee);
export default __webpack_public_path__ + "static/media/fee.7882ec319fc37932796ca6da026f4e4e.svg";
export { ForwardRef as ReactComponent };